// @ts-expect-error untyped dependency
import { setupCsat } from 'wootric-nps/csat/csat-setup';
import unescapedText from 'I18n/utils/unescapedText';
import { UsageScreenProvider } from 'marketplace-ui-tracking';
import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import { DashboardPageWithHero } from '../components/DashboardPageWithHero';
import { StorefrontDashboardWithTabs } from '../components/StorefrontDashboardWithTabs';
import { StorefrontPageMetadata } from '../components/StorefrontPageMetadata';
import { ProductPageHeader } from '../components/headers/ProductPageHeader';
import { AGENT_MIN_SECTION_CARD_COUNT, APP_MIN_SECTION_CARD_COUNT, WORKFLOW_TEMPLATE_MIN_SECTION_CARD_COUNT } from '../constants/suggestions';
import { Screens } from '../constants/usage';
import { useAppContext } from '../context/AppContext';
import { useGates } from '../hooks/useGates';
import { useGetSuggestionSections } from '../hooks/useGetSuggestionSections';
import { useTrackHomepageViewedEvent } from '../hooks/useTrackHomepageViewedEvent';
import { ProductHomeSections } from './components/ProductHomeSections';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ProductPage({
  featuredCollectionId,
  productType
}) {
  var _data$result$sections, _data$result$sections2;
  const pathKey = productType === 'APP' ? 'APPS' : productType === 'WORKFLOW_TEMPLATE' ? 'WORKFLOW_TEMPLATES' : 'AGENTS';
  const screen = productType === 'APP' ? Screens.APPS : productType === 'WORKFLOW_TEMPLATE' ? Screens.WORKFLOW_TEMPLATES : Screens.AGENTS;
  const appContext = useAppContext();
  const gates = useGates();
  const {
    error,
    loading,
    data
  } = useGetSuggestionSections({
    productTypes: [productType],
    minimumSectionCardCount: productType === 'AGENT' ? AGENT_MIN_SECTION_CARD_COUNT : productType === 'WORKFLOW_TEMPLATE' ? WORKFLOW_TEMPLATE_MIN_SECTION_CARD_COUNT : APP_MIN_SECTION_CARD_COUNT
  });
  const halfLength = ((_data$result$sections = data === null || data === void 0 || (_data$result$sections2 = data.result.sections) === null || _data$result$sections2 === void 0 ? void 0 : _data$result$sections2.length) !== null && _data$result$sections !== void 0 ? _data$result$sections : 0) / 2;
  const sections = (data === null || data === void 0 ? void 0 : data.result.sections) || [];
  useTrackHomepageViewedEvent({
    loading,
    screen,
    sections,
    type: String(productType)
  });
  useEffect(() => {
    if (appContext === 'app' && productType === 'APP') {
      setupCsat('ECOSYSTEM_APP_MARKETPLACE');
    }
  }, [appContext, productType]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!!data && productType === 'APP' && /*#__PURE__*/_jsx(NavMarker, {
      name: "APPS_LOAD"
    }), !!data && productType === 'AGENT' && /*#__PURE__*/_jsx(NavMarker, {
      name: "AGENTS_LOAD"
    }), !!data && productType === 'WORKFLOW_TEMPLATE' && /*#__PURE__*/_jsx(NavMarker, {
      name: "WORKFLOW_TEMPLATES_LOAD"
    }), /*#__PURE__*/_jsx(StorefrontPageMetadata, {
      loading: loading,
      title: productType === 'AGENT' ? unescapedText('marketplaceStorefront.documentHead.agents.title') : productType === 'WORKFLOW_TEMPLATE' ? unescapedText('marketplaceStorefront.documentHead.workflowTemplates.title') : unescapedText('marketplaceStorefront.documentHead.apps.title'),
      metaDescription: productType === 'AGENT' ? unescapedText('marketplaceStorefront.documentHead.agents.metaDescription') : productType === 'WORKFLOW_TEMPLATE' ? unescapedText('marketplaceStorefront.documentHead.workflowTemplates.metaDescription') : unescapedText('marketplaceStorefront.documentHead.apps.metaDescription')
    }), /*#__PURE__*/_jsx(UsageScreenProvider, {
      screen: screen,
      children: gates.workflowTemplatesPhase2 ? /*#__PURE__*/_jsx(StorefrontDashboardWithTabs, {
        interleaveBanners: gates.workflowTemplatesPhase2,
        children: /*#__PURE__*/_jsx(ProductHomeSections, {
          error: error,
          featuredCollectionId: featuredCollectionId,
          loading: loading,
          productType: productType,
          sections: sections.slice(0, halfLength),
          remainingSections: sections.slice(halfLength)
        })
      }) : /*#__PURE__*/_jsx(DashboardPageWithHero, {
        headerComponent: /*#__PURE__*/_jsx(ProductPageHeader, {
          pathKey: pathKey
        }),
        children: /*#__PURE__*/_jsx(ProductHomeSections, {
          error: error,
          featuredCollectionId: featuredCollectionId,
          loading: loading,
          productType: productType,
          sections: sections.slice(0, halfLength),
          remainingSections: sections.slice(halfLength)
        })
      })
    })]
  });
}